import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-034dc3f5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "resolving-limitation" }
const _hoisted_2 = { class: "resolving-limitation__heading" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resolving-limitation__title" }, "فایل ویدئویی", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  fill: "#0c1229",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
  })
], -1))
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_resolving_limitation_step_one = _resolveComponent("resolving-limitation-step-one")!
  const _component_resolving_limitation_step_two = _resolveComponent("resolving-limitation-step-two")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.step === 2)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args))),
            class: "resolving-limitation__back-btn"
          }, _hoisted_5))
        : _createCommentVNode("", true)
    ]),
    (_ctx.step === 1)
      ? (_openBlock(), _createBlock(_component_resolving_limitation_step_one, {
          key: 0,
          onRecord: _cache[1] || (_cache[1] = ($event: any) => {
        _ctx.file = $event;
        _ctx.step = 2;
      })
        }))
      : (_ctx.step === 2)
        ? (_openBlock(), _createBlock(_component_resolving_limitation_step_two, {
            key: 1,
            file: _ctx.file,
            onBack: _cache[2] || (_cache[2] = ($event: any) => (_ctx.step = 1)),
            onSuccess: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('done')))
          }, null, 8, ["file"]))
        : _createCommentVNode("", true)
  ]))
}